import LoggerFactory from '../../logger-factory';

const logger = LoggerFactory.createLogger({ formatFn: (message) => `[WS-SDK] ${message}` });

const getLogger = () => logger;

export default getLogger;
